import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export function ArticlesSection() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新文章
            </h2>
            <p className="mt-2 text-sm text-foreground-500">探索最新的使用指南和创作技巧</p>
          </div>
          <Link
            to="/category/tutorial"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-background-300/60 transition-all duration-200 group cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-1.5 mt-3">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-0.5 bg-secondary-50 text-secondary-700 text-xs rounded-md"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}